var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.583 5h3.25a.208.208 0 00.148-.356L13.689.356a.208.208 0 00-.356.144v3.25A1.25 1.25 0 0014.583 5zM5.833 11.354h-.52a.208.208 0 00-.209.209v1.041a.208.208 0 00.209.209h.52a.73.73 0 000-1.459z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 5.833h-3.542A2.083 2.083 0 0112.5 3.75V.208A.208.208 0 0012.292 0H3.333a1.667 1.667 0 00-1.666 1.667v16.666A1.667 1.667 0 003.333 20h13.334a1.667 1.667 0 001.666-1.667V6.042a.208.208 0 00-.208-.209zM5.729 13.854h-.417a.208.208 0 00-.208.209v1.77a.52.52 0 01-1.042 0v-5a.52.52 0 01.521-.52h1.25a1.773 1.773 0 011.762 1.955 1.844 1.844 0 01-1.866 1.586zm6.042 1.98a.52.52 0 01-.401.506.537.537 0 01-.12.014.523.523 0 01-.466-.288l-1.293-2.583c-.056-.113-.22-.157-.22 0v2.35a.52.52 0 01-1.042 0v-5a.52.52 0 01.987-.232s1.24 2.49 1.295 2.59.218.133.218-.018v-2.34a.52.52 0 011.042 0zm4.166-3.334a.52.52 0 01-1.041 0v-.417a.73.73 0 00-1.459 0v2.5a.73.73 0 001.4.288c.025-.059.05-.184-.083-.184h-.17a.52.52 0 010-1.041h.833a.52.52 0 01.52.52v.417a1.77 1.77 0 01-3.541 0v-2.5a1.77 1.77 0 013.542 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.073c424d.svg";
export { ForwardRef as ReactComponent };